import {
  useAccount,
  useBalance,
  useContract,
  useNetwork,
  useProvider,
  useSigner,
} from 'wagmi'
import { useState } from 'react'
import { utils } from 'ethers'
import { GNO_TOKEN_ABI } from '../../abis/gnoToken'
import { OMNI_BRIDGE_MEDIATOR_ABI } from '../../abis/omniBridge'
import {
  openErrorNotificationWithIcon,
  openSuccessNotificationWithIcon,
} from '../../helpers/utilities'

const GNO_ADDRESS = '0x7f477c3F03213970d939104CC436Dc995CF615b5'
const FOREIGN_OMNI_BRIDGE_MEDIATOR_ADDRESS =
  '0x00147c84f13764dcdabaf1cbae622fa6f6839085'

export const useBridge = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [tx, setTx] = useState(null)
  const provider = useProvider()
  const { address } = useAccount()
  const { chain } = useNetwork()

  const { data } = useBalance({
    address,
    token: GNO_ADDRESS,
  })
  const [amount, setAmount] = useState(0)

  // First, we need to get the signer that we will use to sign transactions
  const { data: signer } = useSigner()

  // Get the contract instance for the GNO contract
  const gnoContract = useContract({
    address: GNO_ADDRESS,
    abi: GNO_TOKEN_ABI,
    signerOrProvider: signer,
  })

  // Get the contract instance for the Foreign OmniBridge Mediator contract
  const foreignOmniBridgeMediatorContract = useContract({
    address: FOREIGN_OMNI_BRIDGE_MEDIATOR_ADDRESS,
    abi: OMNI_BRIDGE_MEDIATOR_ABI,
    signerOrProvider: signer,
  })

  const inputChange = (value: number) => {
    setAmount(value)
  }

  async function bridgeTokens() {
    setIsLoading(true)
    // Send the transaction to approve the Foreign OmniBridge Mediator
    try {
      // Approve the Foreign OmniBridge Mediator to transfer the GNO tokens on our behalf
      await gnoContract.approve(
        FOREIGN_OMNI_BRIDGE_MEDIATOR_ADDRESS,
        utils.parseEther(amount.toString())
      )
    } catch (error) {
      setIsLoading(false)
      // eslint-disable-next-line no-unused-expressions
      error.reason
        ? openErrorNotificationWithIcon(error.reason)
        : openErrorNotificationWithIcon(error.message)
      return
    }
    let relayTokensTransaction
    try {
      const gasPrice = await provider.getGasPrice()
      // Create the transaction to relay the tokens
      relayTokensTransaction = await foreignOmniBridgeMediatorContract.relayTokens(
        GNO_ADDRESS,
        address,
        utils.parseEther(amount.toString()),
        {
          gasPrice,
          gasLimit: 350000,
        }
      )
      setTx(relayTokensTransaction)
    } catch (err) {
      setIsLoading(false)
      // eslint-disable-next-line no-unused-expressions
      err.reason
        ? openErrorNotificationWithIcon(err.reason)
        : openErrorNotificationWithIcon(err.message)
      return
    }
    try {
      await relayTokensTransaction.wait()
      openSuccessNotificationWithIcon(
        "Göerli GNO's bridged to Chiado successfully!",
        "Relayed GNO's in Chiado will be available in 2 minutes."
      )
      setIsLoading(false)
      setTx(null)
    } catch (e) {
      setIsLoading(false)
      setTx(null)
      // eslint-disable-next-line no-unused-expressions
      e.reason
        ? openErrorNotificationWithIcon(e.reason)
        : openErrorNotificationWithIcon(e.message)
    }
  }
  return { amount, inputChange, bridgeTokens, address, chain, data, isLoading, tx }
}
